import { KPI_CARD_PROPS } from '../DashboardKPICards/kpiConfig';
import KPICard from '../DashboardKPICards/KPICard';
import { componentsMap as pendingComponentsMap } from '../DashboardPendings/PendingContent/utils';
import { componentsMap as overviewComponentsMap } from '../DashboardOverview/OverviewContent/utils';
import { componentsMap as performanceComponentsMap } from '../DashboardPerformance/PerformanceContent/utils';

const allComponentsMap = {
  todo: { ...pendingComponentsMap },
  overview: { ...overviewComponentsMap },
  performance: { ...performanceComponentsMap },
};

const getCardRenderConfig = ({ tabId, sectionId, item }) => {
  const isKpiSection = tabId === 'performance' && sectionId === 'mini_cards';

  let Component = null;
  let props = {};

  if (isKpiSection) {
    Component = KPICard;
    props = KPI_CARD_PROPS[item.id];
  } else {
    Component = allComponentsMap?.[tabId]?.[sectionId]?.[item.id] ?? null;
    props = item?.props;
  }

  return { Component, props };
};

export default getCardRenderConfig;
